var map = {
	"./auth.js": "cS9E",
	"./lang.js": "ja3g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YVPZ";


//////////////////
// WEBPACK FOOTER
// ./resources/js/store/modules nonrecursive .*\.js$
// module id = YVPZ
// module chunks = 34